import $$ from 'cmn-utils'

const baseUrl = "/api/safety/danger/";
export default {
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    submit: (params) => {
        return $$.post(baseUrl + 'submit', params)
    },
}